import { useQuery } from '@tanstack/react-query';
import { getUser } from 'app/modules/Auth/services';
import { QueryCacheTime } from 'configs/constants';
import { auth } from 'app/modules/Auth/firebaseConfig';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { saveToLocal } from 'utils/cache';
import { LANGUAGE_STORAGE_KEY } from 'locales/i18n';
export const USER_INFO_QUERY_KEY = ['auth', 'user-info'] as const;

export const useUserInfo = () => {
  const { i18n } = useTranslation();

  const query = useQuery({
    queryKey: USER_INFO_QUERY_KEY,
    queryFn: getUser,
    staleTime: Infinity,
    gcTime: QueryCacheTime,
    enabled: !!auth.currentUser,
  });

  const { data } = query;

  useEffect(() => {
    if (data?.preferredLanguage && data?.preferredLanguage !== i18n.language) {
      i18n.changeLanguage(data.preferredLanguage);
      saveToLocal(LANGUAGE_STORAGE_KEY, data.preferredLanguage);
    }
  }, [data, data?.preferredLanguage, i18n.language]);

  return query;
};
